<template>
  <div>
    <div class="col-sm-4 center plp-listingpage">
      <div
        class="article-product-short-details-container PDP view-in--gt-third view-in"
        productfullname="UREA CICA REPAIRBody Milk"
      >
        <a ref="product" :href="filterdata.producturl"
          ><img :src="filterdata.firstimageurl" alt="" />
          <div class="title-container">
            <div class="categoryname">{{ filterdata.productname }}</div>
            <div class="productname">{{ filterdata.productcategory }}</div>
          </div>
        </a>
      </div>
    </div>

    <div v-for="(article, index) in filterdata.AtriclesList" :key="index" class="col-sm-8">
      <div
        class="product-listing-containers"
        :style="{ 'background-image': 'url(' + article.image + ')' }"
      >
        <div class="inner-container">
          <div class="productlistingdatadesc">
            <p v-html="article.description"></p>
          </div>
          <div class="button-container">
            <a :href="article.artcleUrl" role="button"
              ><strong>{{ article.buttonText }}</strong></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import throttle from 'lodash/throttle';
export function isVisible(element) {
  const elementCenter = {
    x: element.getBoundingClientRect().left + element.offsetWidth / 2,
    y: element.getBoundingClientRect().top + element.offsetHeight / 2,
  };
  let pointContainer = document.elementFromPoint(elementCenter.x, elementCenter.y);

  if (
    elementCenter.x < 0 ||
    elementCenter.y < 0 ||
    elementCenter.x > (document.documentElement.clientWidth || window.innerWidth) ||
    elementCenter.y > (document.documentElement.clientHeight || window.innerHeight)
  ) {
    return false;
  }

  do {
    if (pointContainer === element) {
      return true;
    }
  } while ((pointContainer = pointContainer.parentNode));

  return false;
}
export function isElementInViewportTag(element) {
  const rect = element.getBoundingClientRect();

  const isInViewPort =
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

  return isInViewPort;
}
export default {
  name: 'product-loop',
  props: {
    imageUrl: {
      type: String,
    },
    productName: {
      type: String,
    },
    productUrl: {
      type: String,
    },
    productCategory: {
      type: String,
    },
    productBrand: {
      type: String,
    },
    listTittle: {
      type: String,
    },
    productSku: {
      type: String,
    },
    productFullname: {
      type: String,
    },
    category: {
      type: String,
    },
    positionInGrid: { required: false },
    columnsCount: { required: false },
    filterdata: { type: Object, required: true },
    itemcollection: { type: Object, required: true },
    itemindex: { required: false },
  },
  data() {
    return {
      firedImpression: null,
      gridcount: 0,
    };
  },
  mounted() {
    this.fireImpression();
  },
  updated() {
    this.fireImpression();
  },
  methods: {
    chekcount(y, x) {
      let newreturnvalue;

      if (x == y + 1) {
        newreturnvalue = 0;
      }
      return newreturnvalue;
    },

    fireImpression() {
      const scrollCallback = () => {
        if (isVisible(this.$refs.product)) {
          if (this.columnsCount > this.positionInGrid) {
            this.$parent.impressions.push({
              name: this.filterdata.productfullname,
              id: this.filterdata.productsku,
              brand: this.filterdata.productbrand,
              category: this.filterdata.category,
              list: this.filterdata.listtittle,
              dimension48: this.filterdata.productsku,
            });
          }
          let newda = this.chekcount(this.positionInGrid, this.itemcollection.length);
          if (newda == 0) {
            dataLayer.push({
              event: 'nievent',
              eventCategory: 'Ecommerce',
              eventAction: 'Product Impressions',
              eventLabel: this.listTittle,
              event_name: 'view_item_list',
              ecommerce: {
                impressions: JSON.parse(JSON.stringify(this.$parent.impressions)),
              },
            });
            this.$parent.impressions = [];
          }

          window.removeEventListener('scroll', throttledScrollCallback);
        }
      };

      const throttledScrollCallback = throttle(scrollCallback, 500);

      window.addEventListener('scroll', throttledScrollCallback, false);
      window.addEventListener('load', scrollCallback, false);
    },
  },
};
</script>
